export const SET_PASSWORD_FORM_PASSWORD = 'password'
export const SET_PASSWORD_FORM_PASSWORD_CONFIRM = 'passwordConfirm'



// WEBPACK FOOTER //
// ./src/constants/SetPasswordFormFieldName.tsx